
export function cleanEmptyParagraphs(html) {
  // Parse HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  const body = doc.body;
  const nodes = Array.from(body.childNodes);
  const cleanedNodes = [];

  nodes.forEach((node) => {
    if (node.nodeType !== Node.ELEMENT_NODE || node.tagName !== "P") {
      // keep non-paragraph nodes as-is
      cleanedNodes.push(node.outerHTML || node.textContent);
      return;
    }

    const text = node.textContent.replace(/\s/g, ""); // strip spaces/newlines
    if (!text) {
      // empty paragraph -> merge with previous if exists
      if (cleanedNodes.length > 0) {
        // append a newline to the previous paragraph
        cleanedNodes[cleanedNodes.length - 1] = cleanedNodes[cleanedNodes.length - 1].replace(
          /<\/p>$/,
          "\n</p>"
        );
      }
      // do not add this node itself
      return;
    }

    cleanedNodes.push(node.outerHTML);
  });

  return cleanedNodes.join("");
}